import React, { useState,useEffect } from 'react';
import Footer from '../components/Footer';

const Contact = () => {

 useEffect(() => {
        window.scrollTo(0, 0);
    }, []);



    const [formData, setFormData] = useState({
        name: '',
        contact: '',
        address: '',
        description: '',
    });

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleWhatsAppRedirect = () => {
        const { name, contact, address, description } = formData;
        const message = `Name: ${name}%0AContact: ${contact}%0AAddress: ${address}%0ADescription: ${description}`;
        const whatsappUrl = `https://wa.me/918100154008?text=${message}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <>




            <div className="container my-4">
                <div className="d-flex justify-content-center">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb bg-light p-2 rounded">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
                        </ol>
                    </nav>
                </div>
            </div>

            
            <div className="container my-5">


                <div className="row">
                    <div className="col-md-6 mb-4">
                        <form>
                            <div className="mb-3">
                                <label className="form-label">Name</label>
                                <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Contact</label>
                                <input type="text" className="form-control" name="contact" value={formData.contact} onChange={handleChange} />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Address</label>
                                <input type="text" className="form-control" name="address" value={formData.address} onChange={handleChange} />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Description</label>
                                <textarea className="form-control" name="description" rows="3" value={formData.description} onChange={handleChange}></textarea>
                            </div>

                            <button type="button" className="btn btn-success" onClick={handleWhatsAppRedirect}>
                                Send message
                            </button>
                        </form>
                    </div>

                    <div className="col-md-6">
                        <h5 className="mb-3">📩 Email</h5>
                        <p>arogyakunjhomeoclinic@gmail.com</p>

                        <h5 className="mb-3">📞 Phone</h5>
                        <p>+91 8100154008</p>

                        <h5 className="mb-3">📍 Address</h5>
                        <p>
                            Ground Floor Shanti Tara Plaza<br />
                            Sultanpur Rd, Arjunganj,<br />
                            Marhar Mau Kala, Lucknow, Uttar Pradesh 226002
                        </p>

                        <h5 className="mb-3">🕒 Timings</h5>
                        <p>
                            <strong>Mon to Sat:</strong><br />
                            Morning: 9:30 AM – 1:00 PM<br />
                            Evening: 6:00 PM – 8:00 PM<br />
                            <strong>Sunday:</strong> 10:00 AM – 12:30 PM
                        </p>
                    </div>
                </div>


            </div>

            <Footer />
        </>
    );
};

export default Contact;
